<template>
    <div>
        

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-history</v-icon>
                <p style="color: white;">Historial Reasignaciones</p>

            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlHistorial"
                                       :columns="columns"
                                       :params="displayInputs"
                                       @apiDT="apiDT = $event"></DataTable>



                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    export default {
        components: {
            DataTable
        },
        data() {
            return {
                conclusion: false,
                urlHistorial: "ReporteGeneral/HistorialReasignacionesLider",
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                    aiclave:0
                },
                columns: [
                    { name: 'nrreporte', data: 'nrreporte', title: "Reporte" },
                    { name: 'svindice', data: 'svindice', title: "Indice" },
                    { name: 'rlfecha', data: 'rlfecha', title: "Fecha y hora de reasignación" },
                    { name: 'lduslogin', data: 'lduslogin', title: "Nombre líder" },
                    { name: 'uslogin', data: 'uslogin', title: "Login reasignó" },
                ],
            }
        },
        computed: {
            ...mapState(["domain", "informationPage", "permission"]),
        },
        methods: {            
            
        },
        async mounted() {
            let datosreporte = await MetodosGenerales.obtenerSessionReporte('reporte');

            this.displayInputs = {
                nrreporte: datosreporte.nrreporte,
                svindice: datosreporte.svindice,
                aiclave: datosreporte.aiclave,
            };
            let validaConc = await MetodosGenerales.getReporteEstatus(this);

            if (validaConc != 2 ) {
                this.conclusion = true;
            }
            


        }
    }
</script>

